<template>
  <view :id="'vditor-' + point" class="vditor-window"> </view>
</template>

<script>
import Vditor from "./dist/index.min.js"; //1.import一下vditor组件
import "./less/index.less"; //1.import一下vditor组件样式
import ClipboardJS from "clipboard";

export default {
  props: {
    point: {
      type: String,
    },
    content: {
      type: String,
    },
    vditorShowInAi: {
      type: Boolean,
    },
  },
  emits: ["vditorShowInAi"],
  data() {
    return {
      vditorElement: {},
    };
  },
  created() {},
  watch: {
    content(val) {
      if (!this.vditorElement) return;
      this.vditorElement.setValue(this.customEscapeString(val) || "");
    },
  },
  mounted() {
    // #ifndef APP-PLUS
    const that = this;
    // let cdn = process.env.NODE_ENV === 'development' ? "http://dev.appcloud.360qnw.com/vditorjs" : '/vditorjs';
    that.vditorElement = new Vditor(`vditor-${this.point}`, {
      cdn:
        process.env.NODE_ENV === "development"
          ? "https://static.pcdashi.cn/vditorjs"
          : "/vditorjs",
      width: "100%",
      readOnly: true,
      toolbar: [],
      cache: {
        enable: false,
      },
      value: this.customEscapeString(this.content) || "",
      mode: "wysiwyg",
      preview: {
        math: {
          // 处理数学公式起始 $ 后是否允许数字 https://github.com/Vanessa219/vditor
          inlineDigit: true,
        },
      },
      after: () => {
        that.getATab();
        that.vditorElement.disabled();
        that.$emit("update:vditorShowInAi", true);
        const vditorContent = document.getElementById(`vditor-${that.point}`);
        if (!vditorContent) return;
        const vditorReset = vditorContent.querySelector(".vditor-reset");
        const tableDomNodeList = vditorReset.querySelectorAll("table");
        if (tableDomNodeList.length == 0) return;
        tableDomNodeList.forEach((item, index) => {
          const copyElement = document.createElement("div");
          vditorReset.insertBefore(copyElement, item);
          copyElement.setAttribute("class", `table-copy`);
          copyElement.setAttribute(
            "id",
            `vditor-table-copy-${that.point}-${index}`,
          );
          item.setAttribute("id", `table-${that.point}-${index}`);
          copyElement.addEventListener("click", (e) => {
            const idValue = e.target.id;
            const arr = idValue.split("-");
            const id = arr[arr.length - 2];
            const index = arr[arr.length - 1];
            // 找到对应 id 的 table 表格 HTML
            const table = document.getElementById(`table-${id}-${index}`);
            // 点击这个类名区域触发
            let clipboardSelect = `#vditor-table-copy-${id}-${index}`;
            let clipboard = new ClipboardJS(clipboardSelect, {
              text: function () {
                return table;
              },
            });
            // 监听复制成功事件，可选操作
            clipboard.on("success", function (e) {
              uni.showToast({
                title: "复制成功，快去粘贴吧~",
                icon: "none",
              });
            });
            // 监听复制失败事件，可选操作
            clipboard.on("error", function (e) {
              console.log("复制失败", e);
            });
          });
        });
      },
    });
    // #endif
  },
  methods: {
    getATab() {
      const vditorDocument = document.getElementById(`vditor-${this.point}`);
      const allATabs = vditorDocument?.getElementsByTagName("a");
      if (allATabs) {
        const length = allATabs?.length || 0;
        for (let i = 0; i < length; i++) {
          const item = allATabs[i];
          item.setAttribute("target", "_blank");
        }
      }
    },
    customEscapeString(text) {
      // 删除echarts代码中的注释内容及省略号
      const reg = /,?\s*\/\/.*|\/\*[\s\S]*?\*\/\s*,?/g;
      const newText = text
        .replaceAll(reg, "")
        .replaceAll(", ...", "")
        .replaceAll(",...", "");
      // console.log("newText", newText);
      return newText;
    },
  },
};
</script>

<style lang="less">
.vditor-window {
  border: none !important;
  overflow-x: scroll;
  overflow-y: hidden;

  /deep/ .vditor-content {
    min-height: 0 !important;
  }

  /deep/ .vditor-wysiwyg__pre {
    display: none !important;
  }

  /deep/ .vditor-toolbar {
    border-bottom: none;
  }

  /deep/ pre.vditor-reset[contenteditable="false"] {
    opacity: 1;
  }

  /deep/ .vditor-reset {
    font-size: 15px;
    padding: 0 !important;
    background-color: transparent;
    user-select: text;
    cursor: text !important;

    .table-copy {
      background-color: #cccccc;
      border-top-left-radius: 10rpx;
      border-top-right-radius: 10rpx;
      height: 60rpx;
      position: relative;
      cursor: text !important;

      &::before {
        content: "复制";
        position: absolute;
        right: 20rpx;
        top: 0;
        height: 60rpx;
        display: flex;
        align-items: center;
        user-select: none !important;
        cursor: pointer;
      }

      &:active::before {
        height: 70rpx;
        padding-right: 10rpx;
        font-weight: bold;
        user-select: none !important;
      }
    }

    table {
      width: 100% !important;
      max-width: 100%;
      display: inline-table;
      cursor: text;
      margin-bottom: 0 !important;

      th {
        padding: 10px 0 !important;
        white-space: pre-wrap !important;
      }

      td {
        padding: 10px 0 !important;
        text-align: center;
        white-space: pre-wrap !important;
      }
    }
  }

  /deep/ .vditor-panel {
    display: none !important;
  }

  /deep/ .vditor-copy {
    display: block;
    width: 100% !important;
    height: 60rpx !important;
    border-top-left-radius: 10rpx;
    border-top-right-radius: 10rpx;
    overflow: hidden;
    z-index: 1;
  }

  /deep/ .hljs {
    white-space: break-spaces;
    border: 1px solid #d9d9d9 !important;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  /deep/ .vditor-tooltipped__w {
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 60rpx;
    top: 0;
    right: 0;
    padding: 0 30rpx;
    z-index: 9999;
    background-color: #cccccc !important;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  /deep/ .vditor-tooltipped__w::after {
    display: block !important;
    box-sizing: border-box;
    width: auto;
    height: 60rpx;
    line-height: 60rpx;
    font-size: 13px;
    padding: 0;
    // font-weight: bold;
    color: #777777;
    background-color: #cccccc;
    position: absolute;
    top: -30rpx;
    right: 60rpx;
    z-index: 99999;
    opacity: 1;
    content: "复制";
    cursor: pointer;
  }

  /deep/ .vditor-tooltipped__w:active {
    padding: 0 35rpx;
    height: 70rpx;
  }

  /deep/ .mermaid {
    white-space: pre-wrap;
  }

  /deep/ .vditor-wysiwyg__preview {
    /deep/ .language-mermaid {
      min-width: 1000px !important;
    }
  }
}
</style>
